export default __webpack_public_path__ + "static/media/Jason.5fa29da2.png";